import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import PropTypes, { any } from 'prop-types';
import mtop from "./mtop";
import api from "./api";
var apiModels = {
  mtop: mtop,
  api: api
};

// sendSDK 支持 @ali/tbjssdk https://yuque.antfin.com/chenghong.qc/prkdcp/bmliq1
var CndzkEntranceApi = function CndzkEntranceApi(options) {
  this.get = void 0;
  this.apis = void 0;
  var _options$apiModel = options.apiModel,
    apiModel = _options$apiModel === void 0 ? 'mtop' : _options$apiModel,
    _options$applicationT = options.applicationType,
    applicationType = _options$applicationT === void 0 ? 'query' : _options$applicationT,
    _options$apiType = options.apiType,
    apiType = _options$apiType === void 0 ? 'cndzk' : _options$apiType,
    _options$cnDataVersio = options.cnDataVersion,
    cnDataVersion = _options$cnDataVersio === void 0 ? '' : _options$cnDataVersio,
    _options$businessId = options.businessId,
    businessId = _options$businessId === void 0 ? '' : _options$businessId,
    _options$realm = options.realm,
    realm = _options$realm === void 0 ? '' : _options$realm,
    sendSDK = options.sendSDK,
    _options$isJsonpForMt = options.isJsonpForMtop,
    isJsonpForMtop = _options$isJsonpForMt === void 0 ? false : _options$isJsonpForMt,
    _options$hideSensitiv = options.hideSensitiveDivision,
    hideSensitiveDivision = _options$hideSensitiv === void 0 ? true : _options$hideSensitiv;
  if (apiModel == 'mtop') {
    var _apiModels$apiModel = apiModels[apiModel],
      apis = _apiModels$apiModel.apis,
      get = _apiModels$apiModel.get;
    this.get = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(apiName, data) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (data === void 0) {
                data = {};
              }
              return _context.abrupt("return", get(apiType, apiName, _extends({
                applicationType: applicationType,
                cnDataVersion: cnDataVersion,
                businessId: businessId,
                realm: realm,
                isJsonpForMtop: isJsonpForMtop,
                hideSensitiveDivision: hideSensitiveDivision
              }, data), sendSDK));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    this.apis = apis;
  } else if (apiModel == 'api') {
    var ins = new apiModels['api'](options);
    this.get = ins.get;
    this.apis = ins.apis;
  }
};
CndzkEntranceApi.propTypes = {
  apiModel: PropTypes.string,
  applicationType: PropTypes.string,
  apiType: PropTypes.string,
  cnDataVersion: PropTypes.string,
  businessId: PropTypes.string,
  realm: PropTypes.string,
  sendSDK: any,
  isJsonpForMtop: PropTypes.bool
};
export { mtop, CndzkEntranceApi };
export default {
  mtop: mtop,
  CndzkEntranceApi: CndzkEntranceApi
};